"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let CreateRental = class CreateRental extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    defaultCompany;
    async $$load_defaultCompany() {
        return this.$fn.fetch('read_company', { parameters: { id: 'default' } });
    }
    resource;
    async $$load_resource() {
        return this.$fn.schemaDefaults('CreateRental', {
            company: this.defaultCompany,
            valid_from: this.$fn.today()
        });
    }
    editor;
    async $$load_editor() {
        return this.resource.editor();
    }
    container;
    async $$load_container() {
        return {
            self: this.$fn.urlFor('create_rental'),
            object: 'list',
            data: []
        };
    }
    formName;
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    resourceTitle;
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['defaultCompany', 'resource', 'editor', 'container', 'formName', 'formId', 'resourceTitle', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                defaultCompany: null,
                resource: null,
                editor: null,
                container: null,
                formName: "rental",
                formId: null,
                resourceTitle: this.$fn.pgettext("Rental", "Rental"),
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "md",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("Rental", "Create Rental"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_5218_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeComponent_5224_getActionArgs($event) {
        return {
            result: {
                ok: true,
            },
        };
    }
    async act_1040167445267876_navigate_5226_getActionArgs($event) {
        return {
            location: {
                name: "app.rental",
                params: {
                    id: $event.data.response.data.id,
                },
            },
        };
    }
    async act_1040167445267876_reloadSlickgrid_5228_getActionArgs($event) {
        return {
            grid: "rentals",
        };
    }
    async act_1040167445267876_rest_5222_getActionArgs($event) {
        return {
            method: "save",
            container: this.container,
            resource: this.editor,
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_5218 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_5218_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_5217 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_5218,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_5217],
        });
        const act_2248226175642056_closeComponent_5220 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_5219 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_5220,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_5219],
        });
        const act_1040167445267876_closeComponent_5224 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_1040167445267876_closeComponent_5224_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_saved_5223 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeComponent_5224,
            event: "saved",
            displayName: "closeComponent",
        });
        const act_1040167445267876_navigate_5226 = new core_1.actions.NavigateAction({
            actionArgs: this.act_1040167445267876_navigate_5226_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_saved_5225 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_navigate_5226,
            event: "saved",
            displayName: "navigate",
        });
        const act_1040167445267876_reloadSlickgrid_5228 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_1040167445267876_reloadSlickgrid_5228_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_saved_5227 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_reloadSlickgrid_5228,
            event: "saved",
            displayName: "reloadSlickgrid",
        });
        const act_1040167445267876_rest_5222 = new core_1.actions.RestAction({
            actionArgs: this.act_1040167445267876_rest_5222_getActionArgs,
            displayName: "create",
            events: [evh_1040167445267876_saved_5223, evh_1040167445267876_saved_5225, evh_1040167445267876_saved_5227],
        });
        const evh_1040167445267876_submit_5221 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_rest_5222,
            event: "submit",
            displayName: "create",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_5221],
        });
        const act_1419464017721962_closeComponent_5230 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_5229 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeComponent_5230,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_5229],
        });
        return {
            act_7315092382398562_closeModal_5218,
            evh_7315092382398562_close_5217,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_5220,
            evh_2248226175642056_close_5219,
            evh_2248226175642056_close,
            act_1040167445267876_closeComponent_5224,
            evh_1040167445267876_saved_5223,
            act_1040167445267876_navigate_5226,
            evh_1040167445267876_saved_5225,
            act_1040167445267876_reloadSlickgrid_5228,
            evh_1040167445267876_saved_5227,
            act_1040167445267876_rest_5222,
            evh_1040167445267876_submit_5221,
            evh_1040167445267876_submit,
            act_1419464017721962_closeComponent_5230,
            evh_1419464017721962_clickPreventStop_5229,
            evh_1419464017721962_clickPreventStop,
            create: act_1040167445267876_rest_5222,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], CreateRental.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CreateRental.prototype, "onSize", null);
CreateRental = __decorate([
    (0, vue_property_decorator_1.Component)()
], CreateRental);
exports.default = CreateRental;
vue_property_decorator_1.Vue.component("CreateRental", CreateRental);
